import moment from 'moment';
import * as jobActionTypes from './jobActionTypes';

export const initialState = {
  filters: {
    startDate: moment('01 March 2020'), endDate: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    //──── Clear all data ────────────────────────────────────────────────────────────────────
    case jobActionTypes.CLEAR_JOBS_DATA: {
      return initialState;
    }

    //──── Filters ───────────────────────────────────────────────────────────────────────────
    case jobActionTypes.JOBS_UPDATE_FILTERS: {
      return {
        ...state,
        filters: { ...state.filters, ...action.payload }
      };
    }


    default:
      return state;
  }
};